import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
export function collectModuleErrors(app) {
  var _iterator = _createForOfIteratorHelper(app.modules.values()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var mod = _step.value;
      if (mod) {
        var _iterator2 = _createForOfIteratorHelper(mod.errors),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var err = _step2.value;
            app.errors.push(_objectSpread(_objectSpread({}, err), {}, {
              filePath: mod.filePath
            }));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
//# sourceMappingURL=collectModuleErrors.js.map